import React from "react";
import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import ReactTable from "react-table";
import {Card, CardContent} from "@material-ui/core";
import {Button} from "reactstrap";
import {toast} from "react-toastify";

/** Checkout/layaway modal: pick catalog services and add lines to the open cart. */
class CheckoutServicesPicker extends Framework.Components.Collection {
	constructor(props) {
		super(props, new API.BuildClass(Types.Services._name, API.RequestType.READ_ALL));
		this.state.limit = 16;
		this.limit = 16;
	}

	addToCart = (servicePkey, taxable = true) => () => {
		const existingIds = this.props.existingServiceIds || [];
		if (existingIds.some((id) => String(id) === String(servicePkey))) {
			toast.info('This service is already on the checkout. Edit the line to change quantity.', {
				position: toast.POSITION.TOP_RIGHT,
			});
			return;
		}
		const item = new API.BuildClass(Types.Checkouts_Services._name, API.RequestType.CREATE);
		item.object = {
			service: servicePkey,
			quantity: "1",
			taxable: taxable,
		};
		void item.submit(null, API.RequestType.CREATE).then(() => {
			this.handleCheckoutIncrement();
			if (typeof this.props.onServiceAdded === 'function') {
				this.props.onServiceAdded();
			}
		}).catch((err) => {
			const msg = err?.message || 'Could not add service to checkout.';
			toast.error(msg, { position: toast.POSITION.TOP_RIGHT });
		});
	};

	handleCheckoutIncrement = () => {
		this.props.rootState.set({
			session_items_count:
				this.props.rootState.session_items_count === null
					? 1
					: 1 + this.props.rootState.session_items_count,
		});
	};

	render() {
		const {data, loading, limit} = this.state;
		const columns = [
			{
				Header: "Name",
				accessor: "name",
				Cell: (props) => <span>{props.original.name}</span>,
			},
			{
				Header: "Price",
				id: "price",
				accessor: (r) => `$${parseFloat(r.price || 0).toFixed(2)}`,
			},
			{
				Header: "Taxable",
				id: "taxable",
				accessor: (r) => (r.taxable ? "Yes" : "No"),
			},
			{
				Header: "Notes",
				id: "notes",
				accessor: (r) => r.notes || "",
			},
			{
				Header: "Checkout",
				className: "button-cell",
				accessor: "pkey",
				Cell: (props) => (
					<Button className="primary-button" size="sm" onClick={this.addToCart(props.value, props.original.taxable)}>
						Add
					</Button>
				),
			},
		];

		return (
			<Card>
				<CardContent>
					<ReactTable
						columns={columns}
						manual
						data={data}
						loading={loading}
						loadingText="Requesting Data"
						onFetchData={this.fetchData}
						defaultPageSize={limit}
						className="-striped -highlight"
						showPaginationTop={false}
						showPaginationBottom={false}
					/>
				</CardContent>
			</Card>
		);
	}
}

export default Framework.Components.withRootState(CheckoutServicesPicker);
